import script from "./portfolio.vue?vue&type=script&setup=true&lang=js"
export * from "./portfolio.vue?vue&type=script&setup=true&lang=js"

import "./portfolio.vue?vue&type=style&index=0&id=bf59cac8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf59cac8"]])

export default __exports__